/**
 * Couleurs d'un effort, une par cran, selon le nombre de crans sur lesquels il se note. Ce sont
 * celles que l'éditeur applique quand l'élément n'en porte pas les siennes.
 *
 * Elles passent du vert au rouge à mesure que l'effort demandé au client augmente — beaucoup
 * d'effort est un mauvais signe, à l'inverse d'une satisfaction, dont le vert est en haut d'échelle.
 *
 * Les cinq crans de la forme en toutes lettres se lisent sur la palette de cinq : un effort noté par
 * ses libellés se présente toujours sur cinq encadrés, quelle que soit l'étendue chiffrée.
 */
export const EFFORT_PALETTES: Record<number, string[]> = {
    5: ['#52c41a', '#52c41a', '#faad14', '#f5222d', '#f5222d'],
    7: ['#52c41a', '#52c41a', '#52c41a', '#faad14', '#faad14', '#f5222d', '#f5222d'],
    11: [
        '#52c41a',
        '#52c41a',
        '#52c41a',
        '#52c41a',
        '#faad14',
        '#faad14',
        '#faad14',
        '#f5222d',
        '#f5222d',
        '#f5222d',
        '#f5222d',
    ],
};
